import da_DK from './files/da_DK.json';
import en_GB from './files/en_GB.json';
import en_GB_long from './files/en_GB_long.json';
import et_EE from './files/et_EE.json';
import fr_FR from './files/fr_FR.json';
import ro_RO from './files/ro_RO.json';

export const locale = {
  da_DK,
  en_GB,
  en_GB_long,
  et_EE,
  fr_FR,
  ro_RO
};

export const locale_en_main_menu_names = {
  "InHouseStats.TabStats": en_GB["InHouseStats.TabStats"],
  "InHouseStats.TabOverview": en_GB["InHouseStats.TabOverview"],
  "InHouseStats.TabPlayers": en_GB["InHouseStats.TabPlayers"],
  "InHouseStats.TabLineups": en_GB["InHouseStats.TabLineups"],
  "InHouseStats.TabH2H": en_GB["InHouseStats.TabH2H"],
};

export default locale;